import { render } from "./ImportListTableHeader.vue?vue&type=template&id=47d61fa8"
import script from "./ImportListTableHeader.vue?vue&type=script&lang=js"
export * from "./ImportListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__